import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
export const HeaderSection = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const closeMenu = () => {
    setIsMenuOpen(false);
  };
  const scrollToSection = sectionId => {
    closeMenu();
    // If we're not on the homepage, navigate there first
    if (location.pathname !== '/') {
      navigate('/', {
        state: {
          scrollTo: sectionId
        }
      });
      return;
    }
    // If we're already on the homepage, just scroll to the section
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  // Handle scrolling when coming from another page
  useEffect(() => {
    if (location.pathname === '/' && location.state?.scrollTo) {
      const sectionId = location.state.scrollTo;
      // Small delay to ensure the page has loaded
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
        // Clean up the state after scrolling
        window.history.replaceState({}, document.title);
      }, 100);
    }
  }, [location]);
  return <header className="w-full bg-black text-white sticky top-0 z-50" data-id="element-122">
      <div className="container mx-auto px-4" data-id="element-123">
        <div className="flex items-center justify-between h-16" data-id="element-124">
          {/* Company Logo */}
          <div className="flex-shrink-0" data-id="element-125">
            <Link to="/" className="flex items-center" data-id="element-126">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1ZnzkC6g39szrpHy28Rxro/binary_solutions.png" alt="Binary Solutions 101010" className="h-12" data-id="element-127" />
            </Link>
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden md:block" data-id="element-128">
            <ul className="flex space-x-8" data-id="element-129">
              <li data-id="element-130">
                <button onClick={() => scrollToSection('hero')} className="font-medium hover:text-red-600 transition-colors bg-transparent" data-id="element-131">
                  Home
                </button>
              </li>
              <li data-id="element-132">
                <button onClick={() => scrollToSection('about')} className="font-medium hover:text-red-600 transition-colors bg-transparent" data-id="element-133">
                  About
                </button>
              </li>
              <li data-id="element-134">
                <button onClick={() => scrollToSection('services')} className="font-medium hover:text-red-600 transition-colors bg-transparent" data-id="element-135">
                  Services
                </button>
              </li>
              <li data-id="element-136">
                <button onClick={() => scrollToSection('contact')} className="font-medium hover:text-red-600 transition-colors bg-transparent" data-id="element-137">
                  Contact
                </button>
              </li>
            </ul>
          </nav>
          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-138">
            <button onClick={toggleMenu} className="text-white hover:text-red-600 focus:outline-none" data-id="element-139">
              {isMenuOpen ? <XIcon className="h-6 w-6" data-id="element-140" /> : <MenuIcon className="h-6 w-6" data-id="element-141" />}
            </button>
          </div>
        </div>
        {/* Mobile Navigation */}
        {isMenuOpen && <div className="md:hidden py-4 border-t border-gray-800" data-id="element-142">
            <ul className="space-y-4" data-id="element-143">
              <li data-id="element-144">
                <button onClick={() => scrollToSection('hero')} className="block w-full text-left font-medium hover:text-red-600 transition-colors bg-transparent" data-id="element-145">
                  Home
                </button>
              </li>
              <li data-id="element-146">
                <button onClick={() => scrollToSection('about')} className="block w-full text-left font-medium hover:text-red-600 transition-colors bg-transparent" data-id="element-147">
                  About
                </button>
              </li>
              <li data-id="element-148">
                <button onClick={() => scrollToSection('services')} className="block w-full text-left font-medium hover:text-red-600 transition-colors bg-transparent" data-id="element-149">
                  Services
                </button>
              </li>
              <li data-id="element-150">
                <button onClick={() => scrollToSection('contact')} className="block w-full text-left font-medium hover:text-red-600 transition-colors bg-transparent" data-id="element-151">
                  Contact
                </button>
              </li>
            </ul>
          </div>}
      </div>
    </header>;
};